<template>
  <v-layout row wrap>
    <v-flex xs12>
      <!-- HEADER -->
      <h2>
        {{ $t(`page.${page}.title`) }} <span v-if="search">({{ getNumItems }})</span>
      </h2>
      <v-flex v-if="allowAdd" >
        <v-spacer/>
        <v-btn 
          color="warning"
          @click.stop="addAction">
          {{ $t(`page.${page}.create`) }}
        </v-btn>
      </v-flex>
      <BaseFormModal 
        v-if="(allowAdd || allowEdit) && menuOpen"
        :item="editItem"
        :entity="entity"
        :model="model"
        :menu-open.sync="menuOpen"
        :need-invitation="needInvitation"
        @onAdd="onAdd"
        @onUpdate="onUpdate"/>
      <!-- SEARCH OPTION-->
      <div>
        <v-text-field
          v-model="filterText" 
          :label="$t(`page.${page}.search`)"
          class="mt-3 mb-3"
          solo
          prepend-icon="search"
        />
      </div>
      <!-- CUSTOM FILTERS -->
      <slot name="customFilter"/>
      <!-- CARDS|TABLE SELECTOR -->
      <div>
        <!--
        <div class="text-xs-center mb-3">
          <div v-if="!cardModeDisable">
            <v-btn-toggle :input-value="renderMode==='cards' ? 0 : 1">
              <v-btn 
                flat
                @click="setRenderMode('cards')">
                <v-icon>apps</v-icon>
              </v-btn>
              <v-btn 
                flat
                @click="setRenderMode('table')">
                <v-icon>menu</v-icon>
              </v-btn>
            </v-btn-toggle>
          </div>
        </div>
        -->
        <div 
          v-for="(group,i) in itemsGrouped"
          :key="`group_${i}`"
          class="mb-3">
          <h2 v-if="Object.keys(itemsGrouped).length>1">{{ $t(`entity.club.type.optionsPlural.${i}`) }}</h2>
          <template v-if="group.length>0">
            <!-- TABLE RENDER -->
            <!--
            <template v-if="renderMode === 'table'">
              <v-data-table
                :headers="headers"
                :items="group"
                hide-actions
                class="elevation-1" >
                <template 
                  slot="items" 
                  slot-scope="props">
                  <tr>
                    <td 
                      v-for="column in getColumns"
                      v-if="hasValue(props.item, column)"
                      :key="column.name">
                      <slot 
                        :name="column.name"
                        :item="props.item">
                        <template v-if="column.type === 'checkbox'">
                          <BaseTableBoolean :value="props.item[column.name]" />
                        </template>
                        <template v-else-if="column.type === 'textarea'">
                          <BaseTableTextArea :value="props.item[column.name]" />
                        </template>
                        <template v-else-if="column.type === 'image'">
                          <img 
                            v-if="props.item[column.name]" 
                            :src="props.item[column.name]" 
                            class="image-field" 
                            alt="cartel" >
                          <span v-else>---</span>
                        </template>
                        <template v-else>
                          {{ itemValue(props.item, column) }}
                        </template>
                      </slot>
                    </td>
                    <td v-if="allowEdit || allowGo || allowDelete">
                      <slot
                        :item="props.item"
                        name="actions" >
                        <v-btn-toggle class="custom-btn-toggle">
                          <slot 
                            :item="props.item"
                            name="goButton">
                            <v-btn 
                              v-if="allowGo"
                              flat
                              color="primary"
                              @click.stop="goAction(props.item)">
                              <v-icon>send</v-icon>
                            </v-btn>
                          </slot>
                          <slot 
                            :item="props.item"
                            name="editButton">
                            <v-btn  
                              v-if="allowEdit"
                              flat
                              color="warning"
                              @click.stop="editAction(props.item)">
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </slot>
                          <slot 
                            :item="props.item"
                            name="deleteButton" >
                            <DeleteButton 
                              v-if="allowDelete"
                              :item="props.item"
                              :page="page"
                              @onDelete="deleteAction">
                              <v-icon>delete_forever</v-icon>
                            </DeleteButton>
                          </slot>
                        </v-btn-toggle>
                      </slot>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </template>
            -->
            <!-- CARDS RENDER -->
            <template v-if="renderMode === 'cards'">
              <v-layout column>
                <v-flex>
                  <v-container fluid grid-list-md >
                    <v-layout
                      row
                      wrap>
                      <v-flex
                        v-for="(item, i) in group"
                        :key="`item_${item.id}`" 
                        :class="{md6:item.type!=='event',md3:item.type==='event',xs12:item.type!=='event',xs6:item.type==='event'}">
                        <slot  
                          :item="item"
                          :adminMode="adminMode"
                          :index="i"
                          name="card">
                          <v-card>
                            {{ item }}
                          </v-card>
                        </slot>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </template>
          </template>
          <template v-else>
            <!-- NO DATA MESSAGE -->
            <v-alert
              :value="true"
              outline 
              color="info" 
              icon="info" >
              {{ $t(`page.${page}.noData`) }}
            </v-alert>
          </template>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import BaseTableBoolean from '@/components/Base/TableFields/BaseTableBoolean'
import BaseTableTextArea from '@/components/Base/TableFields/BaseTableTextArea'
import BaseFormModal from '@/components/Base/BaseFormModal'
import DeleteButton from '@/components/UIComponents/DeleteButton/DeleteButton'
import DateHelper from '@/lib/DateHelper'
import DataLib from '@/lib/data/data'
const debug = require('debug')('OD::BaseTable')

export default {
  name: 'BaseTable',
  components: { BaseTableBoolean, BaseTableTextArea, BaseFormModal, DeleteButton },
  props: {
    page: {
      type: String,
      required: true,
    },
    entity: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    model: {
      type: Array,
      required: true,
    },
    adminMode: {
      type: Boolean,
      required: true,
    },
    allowAdd: {
      type: Boolean,
      default: true,
    },
    allowGo: {
      type: Boolean,
      default: true,
    },
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    search: {
      type: Boolean,
      default: true,
    },
    cardModeDisable: {
      type: Boolean,
      default: false,
    },
    needInvitation: {
      type: Boolean,
      default: false,
    },
    groupBy: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      menuOpen: false,
      filterText: '',
      editItem: null,
      renderMode: 'cards',
    }
  },
  computed: {
    ...mapState({
      // renderMode: state => state.global.renderMode,
    }),
    itemsGrouped() {
      if (this.itemsFiltered) {
        return DataLib.groupBy(this.itemsFiltered, this.groupBy)
      }
      return []
    },
    itemsFiltered() {
      if (this.items) {
        return DataLib.filter(this.items, this.filterText)
      }
      return []
    },
    getNumItems() {
      const items = this.items || []
      const numTotal = items.length
      if (this.itemsFiltered) {
        const numFiltered = this.itemsFiltered.length
        if (numTotal !== numFiltered) {
          return `${numFiltered}/${numTotal}`
        }
      }
      return numTotal
    },
    getColumns() {
      return this.model.filter(item => {
        return item.tableDisplay
      })
    },
    headers() {
      const headers = this.model
        .filter(item => {
          return item.tableDisplay
        })
        .map(item => {
          return {
            text: this.$t(`entity.${this.entity}.${item.name}.label`),
            align: 'left',
            sortable: false,
            value: item.name,
          }
        })
      if (this.allowEdit || this.allowGo || this.allowDelete) {
        headers.push({
          text: this.$t(`general.actions`),
          align: 'left',
          sortable: false,
          value: 'actions',
        })
      }
      return headers
    },
  },
  created() {
    debug('created')
    /*
    if (this.cardModeDisable) {
      this.setRenderMode('table')
    }
    */
  },
  methods: {
    setRenderMode(mode) {
      // this.$store.dispatch('global/setRenderMode', { mode })
    },
    hasValue(item, column) {
      return item[column.name] !== 'undefined'
    },
    itemValue(item, column) {
      if (item[column.name]) {
        const value = item[column.name]
        switch (column.type) {
          case 'date':
            if (typeof value === 'number') {
              return DateHelper.getDateShortString(value)
            } else {
              return value
            }
          case 'select':
            return this.$t(`entity.${this.entity}.${column.name}.options.${value}`)
          case 'autocompleteClub':
            return typeof value === 'object' ? value.text : value
          default:
            return value
        }
      }
      return '---'
    },
    cropName(string, numMaxCharacters = 15) {
      if (string.indexOf('@') > -1) {
        string = string.slice(0, string.indexOf('@'))
      }
      if (string.length > numMaxCharacters) {
        return string.slice(0, numMaxCharacters) + '...'
      }
      return string
    },
    editAction(item) {
      debug('editAction', item)
      this.editItem = item
      this.menuOpen = true
    },
    addAction() {
      this.editItem = null
      this.menuOpen = true
    },
    onAdd(newitem) {
      debug('onAdd')
      this.$emit('onAdd', newitem)
    },
    onUpdate(newitem, item) {
      debug('onUpdate')
      this.$emit('onUpdate', newitem, item)
    },
    goAction(item) {
      this.$emit('onGo', item)
    },
    async deleteAction(item) {
      debug('deleteAction')
      this.$emit('onDelete', item)
    },
  },
}
</script>

<style lang="scss">
.container.grid-list-md {
  padding: 0px;
}
.custom-btn-toggle {
  .btn {
    opacity: 1;
  }
}
</style>
